import React from 'react';
import { Box, Chip } from '@mui/material';

const STATUS_STYLES = {
  available: { color: '#166534', bg: 'rgba(34,197,94,0.12)', dot: '#22c55e' },
  booked: { color: '#b91c1c', bg: 'rgba(239,68,68,0.12)', dot: '#dc2626' },
  hold: { color: '#c2410c', bg: 'rgba(249,115,22,0.12)', dot: '#f97316' },
  sold: { color: '#374151', bg: 'rgba(107,114,128,0.12)', dot: '#6b7280' },
};

const STATUS_LABELS = {
  available: 'Available',
  booked: 'Booked',
  hold: 'On Hold',
  sold: 'Sold',
};

function StatusBadge({ status }) {
  const key = (status || 'available').toLowerCase().replace(/\s+/g, '');
  const style = STATUS_STYLES[key] || STATUS_STYLES.available;
  const label = STATUS_LABELS[key] || status || 'Available';

  return (
    <Chip
      size="small"
      icon={<Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: style.dot, ml: 0.75, mr: -0.5 }} />}
      label={label}
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        bgcolor: style.bg,
        color: style.color,
        border: 'none',
        '& .MuiChip-icon': { width: 6, height: 6, ml: 0.75 },
      }}
    />
  );
}

export default StatusBadge;
